import React from "react";
import { FormattedMessage } from "react-intl";
import BlogsSection from "./blogsSection/Index";
import dynamic from "next/dynamic";
import CommonQuestions from "src/components/shared/CommonQuestions/CommonQuestions";

const BreadCrumb = dynamic(() =>
  import("src/components/shared/breadCrumb/Index.js")
);
const PageHeader = dynamic(() =>
  import("src/components/shared/PageHeader/PageHeader")
);
const Footer = dynamic(() => import("src/components/shared/Footer/Footer"));

const Index = ({ data }) => {
  const questionsData = data?.questions?.[0]?.categories?.[0]?.posts;

  const targetQuestion = questionsData?.find((question) => question.id === 611);
  const commonQuestionsBackgroundImage = targetQuestion?.data?.image;
  const filteredQuestions = questionsData?.filter(
    (question) => question.id !== 611
  );

  return (
    <div>
      <PageHeader />
      <BreadCrumb title={<FormattedMessage id="blogs" />} />
      <BlogsSection data={data} />
      <CommonQuestions
        commonQuestionsBackgroundImage={commonQuestionsBackgroundImage}
        filteredQuestions={filteredQuestions}
      />
      <Footer />
    </div>
  );
};

export default Index;
